import React from 'react';
import { injectIntl } from 'react-intl';

import ReactEcharts from 'components/HTMLElements/ReactECharts';
import ChartConfig from 'constants/ChartConfig';
import _ from "lodash";

const Chart = ( { data = {}, intl, chatActive, phoneActive, variableName } ) => {
  const area = {};
  var variableValue = undefined;
  const variableValues = [];
  // var variableValues = ['HIGH', 'NEUTRAL', 'LOW'];
  var variableName = variableName;
  const seriesYdata = {};


  _.map(data, (item) => {
    _.map(item, (val) => {
      if ( _.indexOf(variableValues, val[variableName]  ) === -1   )
      variableValues.push( val[variableName] );
    })
  });

  _.map(data, (val) => {
    _.map(val, (item) => {
      variableValue = item[variableName];
      seriesYdata[variableValue] = [
        _.filter( data['FACEBOOK'], [variableName, variableValue ] ).length > 0 ? _.filter( data['FACEBOOK'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
        _.filter( data['TWITTER'], [variableName, variableValue ] ).length > 0 ? _.filter( data['TWITTER'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
        _.filter( data['EMAIL'], [variableName, variableValue ] ).length > 0 ? _.filter( data['EMAIL'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
        _.filter( data['WALK_IN'], [variableName, variableValue ] ).length > 0 ? _.filter( data['WALK_IN'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
      ]
      if( phoneActive ) seriesYdata[variableValue].push( _.filter( data['PHONE'], [variableName, variableValue ] ).length > 0 ? _.filter( data['PHONE'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )
      if( chatActive ) seriesYdata[variableValue].push( _.filter( data['CHAT'], [variableName, variableValue ] ).length > 0 ? _.filter( data['CHAT'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )
    })
  });

  const seriesData = _.map(variableValues, function(item) {

    const data =   {
      name: item !== null ? item : intl.formatMessage( { id: 'Undefined' } ),
      type: 'bar',
      data: seriesYdata[item],
      itemStyle: {
        normal: {
          // color: ChartConfig.color.info
        }
      },
      lineStyle: {
        normal: {
          // color: ChartConfig.color.info
        }
      },
      areaStyle: {
        normal: {
          // color: ChartConfig.color.info
        }
      },
      symbol: 'diamond'
    }
    return  data;
  });

  const series = [
    intl.formatMessage( { id: "facebook" } ),
    intl.formatMessage( { id: "twitter" } ),
    intl.formatMessage( { id: "email" } ),
    intl.formatMessage( { id: "walkin" } ),
  ];
  if( phoneActive ) series.push( intl.formatMessage( { id: "phone" } ) )
  if( chatActive ) series.push( intl.formatMessage( { id: "chat" } ) )

  area.options = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: _.map(variableValues, (item) => {return item ? item : intl.formatMessage( { id: 'Undefined' } )} ),
      textStyle: {
        color: ChartConfig.color.text
      }
    },
    toolbox: {
      show: false
    },
    calculable: true,
    xAxis: [
      {
        type: 'category',
        data: series,
        axisLabel: {
          textStyle: {
            color: ChartConfig.color.text
          }
        },
        splitLine: {
          lineStyle: {
            color: ChartConfig.color.splitLine
          }
        }
      }
    ],
    yAxis: [
      {
        axisLabel: {
          textStyle: {
            color: ChartConfig.color.text
          }
        },
        splitLine: {
          lineStyle: {
            color: ChartConfig.color.splitLine
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ChartConfig.color.splitArea
          }
        }
      }
    ],
    series: seriesData
  };
  return (
    <ReactEcharts style={{ height: '300px' }} option={area.options} showLoading={false}/> );
};

module.exports = injectIntl( Chart );



// WEBPACK FOOTER //
// ./routes/app/components/Dashboard/DynamicKPIsChart.js